import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Flex, Button } from 'rebass';
import moment from 'moment-timezone';
import helpers from 'utils/helpers';
import { FiAlertCircle, FiEye } from "react-icons/fi";
import ReactTooltip from 'react-tooltip';

class ParticipantItem extends React.Component {
    constructor(props) {
        super(props);

        this.renderHorizontal = this.renderHorizontal.bind(this);
        this.renderVertical = this.renderVertical.bind(this);
    }

    renderHorizontal(customDataColumns) {
        return customDataColumns;

        /*return (
            <Flex flexWrap="wrap" style={{ position: 'relative', width: '100%' }}>
                {customDataColumns}
            </Flex>
        );*/
    }

    renderVertical() {
        alert('fix stuff in here');
        return (
            <div>
                <div>
                    <Link to={`/participants/${this.props.participant.id}`}>
                        {this.props.participant.first_name} {this.props.participant.last_name}
                    </Link>
                </div>
                <div>{this.props.participant.email}</div>
                <div>{this.props.participant.phone_number}</div>
            </div>
        );
    }

    render() {
        const customDataColumns = [];
        const that = this;

        const chx = <input
                        type="checkbox"
                        key={`checkbox-${this.props.participant.id}`}
                        data-personid={this.props.participant.id}
                        checked={this.props.checkbox_checked[this.props.participant.id]}
                        onChange={this.props.onChange}
                        name="person_id"
                        style={{
                            position: 'absolute',
                            top: '16px',
                            left: '0'
                        }}
                        onClick={e => {
                            e.stopPropagation();
                        }}
                        disabled={['all', 'custom_count'].includes(this.props.checkAllOrVisibleStatus)}
                    />;
        // console.log(this.props.participant.custom_data_keys, this.props.availableColumns_showing);
        //if (this.props.participant.custom_data_keys && this.props.participant.custom_data_keys.length > 0) {


            let tooltip_info = [];
            if (this.props.participant.panelist_eligibility) {
                this.props.participant.panelist_eligibility.forEach(pe => {
                    tooltip_info.push(pe);
                })
            }
            let tooltip_element;
            if (tooltip_info.length) {
                tooltip_element = <span>
                    <FiAlertCircle
                        data-tip
                        data-for={`notif-${this.props.participant.id}`}
                        style={{ margin: '5px 8px 0 0' }}
                        className={`va-top red`}
                    />
                    <ReactTooltip id={`notif-${this.props.participant.id}`} effect="solid" place="right" className="react-tooltip-hover-stay" delayHide={500}>
                        <ul className='tight'>
                            {tooltip_info.map(ti => <li>{ti}</li>)}
                        </ul>
                    </ReactTooltip>
                </span>;
            }

            this.props.availableColumns_showing.forEach((col_showing, index) => {
                //console.log('col_showing', col_showing)
                //const col = this.props.participant.custom_data_keys.find(p_cdk => col_showing.id == p_cdk.id);
                const col = col_showing;
                //console.log('col', col)
                //if (!col || !col_showing.checked) {
                if (!col || !col_showing.checked) {
                    // skip rendering this column
                    return;
                }

                //console.log(this.props.participant.custom_data_values2, col.id)
                const foundValue = this.props.participant.custom_data_values2[col.id];
                let displayValue;
                if (foundValue) {
                    displayValue = foundValue;
                    // console.log(col, displayValue);
                    if (col.type == 'date' && displayValue) {
                        displayValue = moment
                            .utc(displayValue)
                            .tz(this.props.auth.user.timezone)
                            .fromNow();
                    } else if (col.type == 'dropdown' && displayValue) {
                        //const cdk = this.props.participant.custom_data_keys.find(cdk => cdk.id == col.id);
                        const cdk = col_showing;
                        if (cdk && cdk.definition) {
                            const d_found = cdk.definition.find(d => d.value == displayValue);
                            if (d_found) {
                                displayValue = d_found.label;
                            }
                        }
                    } else if (col.type == 'checkbox' && displayValue) {
                        //console.log('displayValue', displayValue)
                        if (helpers.isJsonString(displayValue)) {
                            displayValue = JSON.parse(displayValue);
                            //console.log('displayValue', displayValue)
                            if (displayValue && Array.isArray(displayValue)) {
                                displayValue = displayValue.map((val, index) => {
                                    return val + (index < displayValue.length - 1 ? ', ' : '');
                                })
                            } else {
                                console.log('error displayValue', displayValue)
                                displayValue = 'error';
                            }
                        }
                    }
                }

                // boolean types variable should be represented as 'True' or 'False' instead of 1/0
                if (col.type === 'boolean' && typeof displayValue !== 'undefined')
                    displayValue = Number(displayValue) > 0 ? 'True' : 'False';

                customDataColumns.push(
                    <td
                        style={index == 0 ? { position: 'sticky', left: 0, zIndex: 2 } : {}}
                        className={index == 0 ? 'sticky-row-style td-row-hover-parent' : ''}
                    >
                        {index == 0 && chx}
                        <Flex
                            key={`cdc-${that.props.participant.id}-${col.id}`}
                            className="ellipsis"
                            style={{ paddingLeft: index == 0 ? '8px' : '0', minWidth: '100px', maxWidth: '240px' }}
                        >   
                            {index == 0 && tooltip_element}
                            <Link className="muted" to={`/participants/${this.props.participant.id}`} style={{display: 'block', position: 'relative'}}>
                                {index == 0 ?
                                    <>{displayValue || <em>missing name</em>}</>
                                    :
                                    displayValue
                                }
                            </Link>
                            {index == 0 && <div className='td-row-hover-child' style={{position: 'absolute', right: '8px', top: '11px'}}><Button type='button' variant='secondary' className='secondary-tiny secondary-tiny-icon' onClick={(e) => { e.preventDefault();e.stopPropagation(); this.props.onClickPreviewPanelist(this.props.participant); }}><FiEye style={{margin: '4px 2px 0 2px', fontSize: '14px' }}/></Button></div>}
                        </Flex>
                    </td>
                );
            });
        //}

        if (this.props.horizontal) {
            return this.renderHorizontal(customDataColumns);
        }
        return this.renderVertical(customDataColumns);
    }
}

export default ParticipantItem;
